// extracted by mini-css-extract-plugin
module.exports = {"OutboundLink":"OutboundLink_OutboundLink__a7USS","externalLinkIcon":"OutboundLink_externalLinkIcon__GExhg"};